import React from "react"
import { Box, IconButton, Typography, Backdrop } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

interface VotingSidebarProps {
  open: boolean
  onClose: () => void
  cusip: string
  description?: string
  votingUrl?: string
}

const VotingSidebar: React.FC<VotingSidebarProps> = ({
  open,
  onClose,
  cusip,
  description,
  votingUrl = "https://tesla-meeting.govotr.com/?noOfShares=1&isManagedAccount=false&accountNo=81448132-06f5-4355-0000-aasaas&iframe=true",
}) => {
  const [error, setError] = React.useState(false)

  const handleIframeError = () => {
    setError(true)
  }

  if (!open) {
    return null
  }

  return (
    <>
      {/* Backdrop */}
      <Backdrop
        open={open}
        onClick={onClose}
        sx={{
          zIndex: 1200,
          bgcolor: "rgba(0, 0, 0, 0.3)",
        }}
      />

      {/* Sidebar */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          width: "50vw", // Sidebar takes 50% of viewport width
          backgroundColor: "white",
          boxShadow: "-4px 0 20px rgba(0, 0, 0, 0.15)",
          zIndex: 1300,
          display: "flex",
          flexDirection: "column",
          transform: open ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.3s ease-in-out",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            borderBottom: "1px solid #e0e0e0",
            backgroundColor: "#f8f9fa",
          }}
        >
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Voting Interface
            </Typography>
            {cusip && (
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                CUSIP: {cusip}
              </Typography>
            )}
            {description && (
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {description}
              </Typography>
            )}
          </Box>
          <IconButton
            onClick={onClose}
            sx={{
              "&:hover": { bgcolor: "rgba(0, 0, 0, 0.1)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          {error ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                p: 3,
                textAlign: "center",
              }}
            >
              <Typography variant="body1" color="error">
                Failed to load voting interface. Please try again.
              </Typography>
            </Box>
          ) : (
            <iframe
              id="voting-iframe"
              src={votingUrl}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                display: "block",
              }}
              onError={handleIframeError}
              title={`Voting interface for CUSIP ${cusip}`}
              sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
            />
          )}
        </Box>
      </Box>
    </>
  )
}

export default VotingSidebar
